module.exports = __webpack_public_path__ + "static/img/login-logo.98790b7f.png";